import { memo } from "react";
import { Image } from "react-native";
import "@visioni/a3s-ui/theme";
import { StyleSheet } from "react-native-unistyles";
import { View, Text } from "@visioni/a3s-ui/components";

export type AccessCardThumbnailProps = {
  url?: string | null | undefined;
  width?: number;
  height?: number;
  placeholderText?: string;
};

const THUMBNAIL_SIZE = 56;

export const AccessCardThumbnail = memo(
  ({
    url,
    width = THUMBNAIL_SIZE,
    height = THUMBNAIL_SIZE,
    placeholderText = "No image",
  }: AccessCardThumbnailProps) => {
    return (
      <View style={[styles.container, { width, height }]}>
        {url ?
          <Image source={{ uri: url }} style={styles.image} resizeMode="cover" />
        : <View style={styles.placeholder}>
            <Text textStyle="xxs/regular" color="textMuted">
              {placeholderText}
            </Text>
          </View>
        }
      </View>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    borderRadius: theme.spacing.sm,
    overflow: "hidden",
    backgroundColor: theme.colors.border,
  },
  image: {
    width: "100%",
    height: "100%",
  },
  placeholder: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
}));
